<template>
  <div class="invoices">

    <!-- [ Header ] start -->
    <!--<Header :open="open" @showMenu="showMenu" @hideMenu="hideMenu" />-->
    <!-- [ Header ] end -->

    <div class="content">
      <!-- [ Menu ] start -->
      <!--<Menu :open="open" @companyName="companyName"/>-->
      <!-- [ Menu ] end -->

      <div class="wrap">

        <div class="wrap__center">
          <h3>Invoices</h3>
          <el-row>
            <el-col :span="24">
              <el-button type="success" plain @click="handleCreateInvoice" size="mini" icon="el-icon-plus">Create Invoice</el-button>

            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-table
                :data="tableList.filter(data => !this.search || data.subject.toLowerCase().includes(this.search.toLowerCase()))"
                style="width: 100%"
                @cell-click="cellClick">
                <el-table-column
                  label="Create Date">
                  <template slot-scope="scope">
                    <div>{{moment(scope.row.createDate * 1000).format("D MMM YY")}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Subject"
                  prop="subject">
                </el-table-column>
                <el-table-column
                  label="Status">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.isPayed == 1" style="width: 80px; text-align: center;" type="success" size="medium">Paid</el-tag>
                    <el-tag v-else size="medium">Expects</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  align="right">
                  <template slot="header" slot-scope="{}">
                    <el-input
                      v-model="search"
                      size="mini"
                      placeholder="Type to search"/>
                  </template>
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      icon="el-icon-bank-card"
                      v-if="scope.row.isPayed == 0"
                      @click="handlePay(scope.$index, scope.row)"></el-button>
                    <a :href="linkPrint(scope.row)" target="_blank" class="btn">
                      <el-button
                        size="mini"
                        icon="el-icon-printer"
                        type="warning"
                        plain
                        @click="handlePrint(scope.$index, scope.row)"></el-button>
                    </a>
                    <el-button
                      size="mini"
                      type="primary"
                      plain
                      @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      plain
                      @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>

        </div>

      </div>
    </div>

    <!-- [ Modal form Invite Vendor ] start -->
    <InviteVendor ref="modal"/>
    <!-- [ Modal form Invite Vendor ] end -->
  </div>
</template>

<script>
import moment from 'moment'
// import Header from '@/components/Header.vue'
// import Menu from '@/components/Menu.vue'
import InviteVendor from '@/components/vendors/InviteVendor.vue'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  name: 'Invoices',
  components: {
    // Header,
    // Menu,
    InviteVendor,
    SweetModal,

  },
  computed: {
    invoicesList() {
      return this.$store.getters.getInvoicesList
    }
  },
  watch: {
    invoicesList(val) {
      this.tableList = val
    }
  },
  created() {
    this.$store.dispatch('getInvoicesList', this.$route.query.projectId)
  },
  data() {
    return {
      // open: false,
      companyNameSelect: '',
      moment:moment,

      // Main table
      tableList: [],
      search: '',
    }
  },
  methods: {
    linkPrint(row) {
      console.log('---', row);
      return `/api/v1/projectBillSheets/print1?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectBillSheetId=${row.id}&access_token=${sessionStorage.getItem('token')}`
    },
    // showMenu() {
    //   this.open = true
    //   console.log('---', this.open);
    // },
    // hideMenu() {
    //   this.open = false
    //   console.log('---', this.open);
    // },
    // companyName(name) {
    //   console.log('---companyName', name);
    //   this.companyNameSelect = name
    // },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    cellClick(row, column, event){
      if(column.label !== 'Operations'){
        console.log('---', column);
        console.log('---', event);
      }
    },
    handleCreateInvoice() {
      this.$router.push(`/create-invoices?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`);
    },
    handlePay(index, row) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/projectBillSheet/pay?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectBillSheetId=${row.id}`)
          .then(response => {
              console.log('---/projectBillSheet/pay', response.data);

              this.$store.dispatch('getInvoicesList', this.$route.query.projectId)
              this.notification("Success", "Pay", "success");
          })
          .catch(error => {
              console.log('An error occurred:', error);
          });
    },
    handlePrint(index, row) {
      console.log(index, row);
    },
    handleEdit(index, row) {
      console.log(index, row);

      this.$router.push(`/edit-invoices?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectBillSheetId=${row.id}`)
      // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      // axios
      //     .post(`/api/v1/projectBillSheet/item?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectBillSheetId=${row.id}`)
      //     .then(response => {
      //         console.log('---/projectBillSheet/item', response.data);

      //         // this.$store.dispatch('getInvoicesList', this.$route.query.projectId)
      //         // this.notification("Success", "Delete Invoice", "success");
      //     })
      //     .catch(error => {
      //         console.log('An error occurred:', error);
      //     });
    },
    handleDelete(index, row) {
      this.$confirm('This will permanently delete invoice. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete Invoice'
        });

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/projectBillSheet/delete?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectBillSheetId=${row.id}`)
            .then(response => {
                console.log('---/projectBillSheet/delete', response.data);

                this.$store.dispatch('getInvoicesList', this.$route.query.projectId)
                this.notification("Success", "Delete Invoice", "success");
                loader.hide()
            })
            .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    item(index, row) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/projectBillSheet/item?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectBillSheetId=${row.id}`)
          .then(response => {
              console.log('---/projectBillSheet/item', response.data);

              // this.$store.dispatch('getInvoicesList', this.$route.query.projectId)
              // this.notification("Success", "Delete Invoice", "success");
          })
          .catch(error => {
              console.log('An error occurred:', error);
          });
    }
  },
}
</script>

<style lang="scss" scoped>
.invoices {
  background: #f2f4f7;
  height: 100vh;
}

.content {
  display: flex;
  height: 100vh;
  padding-top: 50px;
}

// [ Wrapper ] start
.wrap {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 20px 10px 10px 10px;

  &__center {
    min-width: 1100px;
    h3 {
      margin: 0;
      font-size: 14px;
      color: #909399;
      margin-bottom: 10px;
    }
  }
}
// [ Wrapper ] end

// [ Nav tree ] start
.nav-tree {
  padding-bottom: 10px;
  &__item {
    margin: 0 0 5px 0;
  }
  .el-button {
    margin-right: 10px;
  }
}
// [ Nav tree ] end

// [ Modal ] start
.button{
  cursor: pointer;
}
// [ Modal ] end

.el-row {
  margin-bottom: 20px;
}

.btn {
  margin: 0 10px;
}
</style>

